// Categories
export const MOTOS_CATEGORY1_ID = 3000
export const QUADS_CATEGORY1_ID = 3100
export const CLASSIC_MOTOS_CATEGORY1_ID = 3200
export const BUGGIES_CATEGORY1_ID = 3500
export const MINIMOTOS_CATEGORY1_ID = 3600

export const CATEGORIES_IDS = {
  BUGGIES: BUGGIES_CATEGORY1_ID,
  CLASSIC_MOTOS: CLASSIC_MOTOS_CATEGORY1_ID,
  MINIMOTOS: MINIMOTOS_CATEGORY1_ID,
  MOTOS: MOTOS_CATEGORY1_ID,
  QUADS: QUADS_CATEGORY1_ID
}

export const CATEGORIES_LEVEL_1 = {
  [CATEGORIES_IDS.BUGGIES]: {
    icon: 'carBuggie',
    id: CATEGORIES_IDS.BUGGIES,
    name: 'COMMON.CATEGORIES.BUGGIES'
  },
  [CATEGORIES_IDS.CLASSIC_MOTOS]: {
    icon: 'motoClassic',
    id: CATEGORIES_IDS.CLASSIC_MOTOS,
    name: 'COMMON.CATEGORIES.CLASSIC_MOTOS'
  },
  [CATEGORIES_IDS.MINIMOTOS]: {
    icon: 'minimotos',
    id: CATEGORIES_IDS.MINIMOTOS,
    name: 'COMMON.CATEGORIES.MINIMOTOS'
  },
  [CATEGORIES_IDS.MOTOS]: {
    icon: 'motoClassic',
    id: CATEGORIES_IDS.MOTOS,
    name: 'COMMON.CATEGORIES.MOTOS'
  },
  [CATEGORIES_IDS.QUADS]: {
    icon: 'quads',
    id: CATEGORIES_IDS.QUADS,
    name: 'COMMON.CATEGORIES.QUADS'
  }
}

// Categories with electric features
export const CATEGORIES_WITH_ELECTRIC_FEATURES = [MOTOS_CATEGORY1_ID, CLASSIC_MOTOS_CATEGORY1_ID]
